export default __webpack_public_path__ + "images/models/7666292be80c369d7c4e740146fe0a5f.usdz";